const {
  SOURCE_UA_2020_03_26_SPELLS_AND_MAGIC_TATTOOS,
} = require('./../../../../sourceList')
const {
  ARMOR_TYPE_NATURAL,
} = require('./../../../../armorTypeList')
const {
  SIZE_MEDIUM,
} = require('./../../../../sizeList')
const {
  CREATURE_TYPE_MONSTROSITY,
} = require('./../../../../creatureTypeIdList')
const {
  LANG_COMMON,
  LANG_ITS_CREATOR,
} = require('./../../../../languageIdList')
const {
  ALIGNMENT_NE,
} = require('./../../../../aligmentList')
const {
  SPEED_WALK,
} = require('./../../../../speedList')
const {
  ATTACK_MELEE_WEAPON,
} = require('./../../../../attackTypeList')
const {
  DAMAGE_COLD,
  DAMAGE_NECROTIC,
} = require('./../../../../damageTypeList')
const {
  CONDITION_FRIGHTENED,
} = require('./../../../../conditionList')
const {
  SENSE_DARK_VISION,
} = require('./../../../../senseList')
const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  GENDER_MALE,
} = require('./../../../../genderList')
const {
  CREATURE_FURY_SHADOW_SPIRIT_2020_03_26,
  CREATURE_FURY_SHADOWSPAWN_SPIRIT,
} = require('./../../../../creatureIdList')
const {
  SPELL_SUMMON_SHADOW_SPIRIT_2020_03_26,
} = require('./../../../../spellIdList')

module.exports = {
  name: 'Дух яростной тени',
  nameEn: 'Fury Shadow Spirit',
  id: CREATURE_FURY_SHADOW_SPIRIT_2020_03_26,
  releasedAs: CREATURE_FURY_SHADOWSPAWN_SPIRIT,
  createdBySpellId: SPELL_SUMMON_SHADOW_SPIRIT_2020_03_26,
  sizeType: SIZE_MEDIUM,
  creatureTypeIdList: [
    CREATURE_TYPE_MONSTROSITY,
  ],
  alignmentId: ALIGNMENT_NE,
  source: {
    id: SOURCE_UA_2020_03_26_SPELLS_AND_MAGIC_TATTOOS,
    page: 7,
  },
  armor: {
    ac: 11,
    type: ARMOR_TYPE_NATURAL,
    comment: `+ круг заклинания`,
  },
  hp: `модификатор Телосложения духа + модификатор заклинательной характеристики заклинателя + десятикратный круг заклинания`,
  speed: {
    [SPEED_WALK]: 40,
  },
  params: {
    [PARAM_STR]: 13,
    [PARAM_DEX]: 16,
    [PARAM_CON]: 15,
    [PARAM_INT]: 4,
    [PARAM_WIT]: 10,
    [PARAM_CHA]: 16,
  },
  resistanceList: [
    DAMAGE_NECROTIC,
  ],
  immunityConditionList: [
    CONDITION_FRIGHTENED,
  ],
  senseList: [
    {
      id: SENSE_DARK_VISION,
      value: 120,
    },
  ],
  languageList: [
    LANG_COMMON,
    {
      id: LANG_ITS_CREATOR,
      doNotSpeak: true,
    },
  ],
  featureList: [
    {
      name: 'Кровожадное бешенство',
      description: `★СУЩЕСТВО★ получает преимущество к атакам по испуганным существам.`,
    },
  ],
  actionList: [
    {
      name: 'Мультиатака',
      description: `★СУЩЕСТВО★ совершает число атак, равное половине круга заклинания`,
    },
    {
      name: 'Леденящий удар',
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: {
          value: 3,
          comment: `+ круг заклинания`,
        },
        range: 5,
        hit: {
          type: DAMAGE_COLD,
          diceCount: 2,
          diceType: 8,
          diceBonus: 3,
          comment: ` + круг заклинания`,
        },
      },
    },
    {
      name: 'Страшный вопль',
      limit: {
        count: 1,
        period: 'день',
      },
      description: `★СУЩЕСТВО★ вопит.  Каждое существо в пределах 30 футов от него должно пройти испытание Мудрости против сложности заклинаний заклинателя или испугаться его на 1 минуту. Испуганное существо может повторять испытание в конце каждого своего хода, завершая эффект при успехе.`,
    },
  ],
  genderId: GENDER_MALE,
}
